(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cfs-procurement-header"] && !Shopify.designMode) return;
  try {
    function cfsInitMobileMenuAccessibility() {
  const trigger = document.querySelector('.cfs-procurement-header__mobile-menu .responsive-menu');
  const menu = document.querySelector('.mobile-version .menu-mobile');
  if (!trigger || !menu || trigger.dataset.cfsA11yReady) return;
  trigger.dataset.cfsA11yReady = 'true';
  if (!menu.id) menu.id = 'cfs-mobile-navigation';
  trigger.setAttribute('aria-controls', menu.id);
  let keyboardOpening = false;
  let wasOpen = menu.classList.contains('opened');
  const syncMenu = () => {
    const open = menu.classList.contains('opened');
    if (!open && wasOpen && menu.contains(document.activeElement)) trigger.focus();
    trigger.setAttribute('aria-expanded', String(open));
    trigger.setAttribute('aria-label', open ? trigger.dataset.cfsCloseLabel : trigger.dataset.cfsOpenLabel);
    menu.inert = !open;
    menu.setAttribute('aria-hidden', String(!open));
    if (open && keyboardOpening) {
      keyboardOpening = false;
      const firstLink = Array.from(menu.querySelectorAll('a[href],button,summary,[tabindex="0"]')).find(element => element.checkVisibility());
      if (firstLink) firstLink.focus();
    }
    wasOpen = open;
  };
  trigger.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    if (event.repeat) return;
    keyboardOpening = !menu.classList.contains('opened');
    trigger.click();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !menu.classList.contains('opened')) return;
    const bodyContent = document.getElementById('body-content');
    if (!bodyContent) return;
    event.preventDefault();
    bodyContent.click();
    trigger.focus();
  });
  new MutationObserver(syncMenu).observe(menu, {attributes: true, attributeFilter: ['class']});
  syncMenu();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', cfsInitMobileMenuAccessibility, {once: true});
} else {
  cfsInitMobileMenuAccessibility();
}
document.addEventListener('shopify:section:load', cfsInitMobileMenuAccessibility);
  } catch(e) { console.error(e); }
})();

})();
